import apiClient from '../client/api-client'
const auth = 'auth'

export default {
  async login(payload) {
    try {
      const { data } = await apiClient.post('users/v2/authorize', {
        grant_type: 'username_password',
        password: payload.password,
        scope: 'openid profile',
        username: payload.username
      })
      if (data) {
        localStorage.setItem('default_auth_token', data.access_token)
        localStorage.setItem('id_token', data.id_token)
      }
      return data
    } catch (err) {
      localStorage.removeItem('default_auth_token')
      localStorage.removeItem('id_token')
      throw new Error(err)
    }
  },
  /*
  Reset password of user by passing email
   */
  async resetPassword(payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data } = await apiClient.post(`${auth}/reset_password`, payload)
      return data
    } catch (err) {
      throw new Error(err)
    }
  }
}
